/*@flow*/
import L from 'leaflet';
import type { DeckPropsT } from '../types';
import { useEffect, useState } from 'react';
import useLayer from '../useLayer';
import {
  defaultPopUpOptions,
  type WithPopup,
  type PopupOptionsT,
} from './Popup';

type MultiPolygonT = { type: 'MultiPolygon', coordinates: number[][][][] };

type OptionsT = {
  geojson: MultiPolygonT,
  clickable?: boolean,
  active?: boolean,
  popupOptions?: PopupOptionsT,
  // ... also all Path options of Leaflet
};

export default (props: DeckPropsT<OptionsT>) => {
  const { options, owner } = props;
  const [element, setElement] = useState();
  const { geojson, clickable, popupOptions } = options;

  useEffect(() => {
    const el: WithPopup<Leaflet$Polygon> = L.geoJSON(geojson, {
      style: () => options,
    });
    clickable && el.on('click', v => owner.fire('click', v));

    if (popupOptions && popupOptions.enabled) {
      const opts = { ...defaultPopUpOptions, ...popupOptions };
      const html = "<div class='pop-component'></div>";
      el.bindPopup(html, opts);
    }

    setElement(() => el);

    return () => {
      el.unbindPopup();
    };
  }, [options]);

  useLayer<OptionsT>(props, element);
};
